import styled from 'styled-components'

export const SejaParceiroWrapper = styled.div`
  background: #8bf9a2;
  & .container {
    display: flex;
    justify-content: space-around;
    height: 420px;
  }

  & .logo {
    background: url(https://imagens-site-riber.s3.sa-east-1.amazonaws.com/parceiro_1.png)
      #8bf9a2 no-repeat center;
    background-size: contain;
    background-position: center;
    width: 100%;
  }

  .formulario {
    display: flex;
    justify-content: center;
    gap: 2rem;
    padding: 40px;
    width: 100%;

    .icon {
      color: var(--roxo-riber);
      margin-bottom: 20px;
    }

    h4 {
      color: #4c4c4c;
      font-weight: 700;
      font-size: 2.5rem;
      line-height: 3rem;
      margin-bottom: 0;
    }

    input,
    .button-form {
      height: 56px;
      border-radius: 26px;
      width: 100%;
      max-width: 365px;
      font-size: 1rem;
      padding: 0 20px;
      border: 2px solid #e0e0e0;
      transition: all 0.3s ease;
      box-sizing: border-box;
    }

    .button-form {
      background: var(--roxo-riber);
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      margin-top: 15px;
      height: 56px;
      border-radius: 26px;
      width: 100%;
      max-width: 340px;
      font-size: 1rem;
      transition: all 0.3s ease;
      box-sizing: border-box;

      &:hover {
        opacity: 0.9;
      }
    }

    @media screen and (max-width: 991px) {
      .container {
        flex-direction: column;
        justify-content: center;
        row-gap: 20px;
      }

      h4 {
        font-size: 2rem;
      }

      input,
      .button-form {
        height: 50px;
        max-width: 100%;
      }
    }

    @media screen and (max-width: 768px) {
      padding: 30px;

      h4 {
        font-size: 1.8rem;
        line-height: 2.2rem;
      }

      input,
      .button-form {
        height: 48px;
        font-size: 0.9rem;
      }

      .button-form {
        margin-top: 10px;
        width: 195px;
      }
    }

    @media screen and (max-width: 480px) {
      padding: 20px;
      gap: 1rem;

      h4 {
        font-size: 1.5rem;
        line-height: 1.8rem;
      }

      input,
      .button-form {
        height: 44px;
        border-radius: 22px;
        font-size: 0.85rem;
        padding: 0 15px;
      }

      .button-form {
        margin-top: 10px;
      }
    }
  }
`

export const FilosofiaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 40px;
  flex-grow: 1;

  & h4 {
    color: #4c4c4c;
    font-size: 3rem;
    font-weight: 700;
  }

  & p {
    color: #4c4c4c;
    font-size: 1.7rem;
    font-weight: 400;
  }

  @media screen and (max-width: 991px) {
    & h4 {
      font-size: 3rem;
    }

    & p {
      font-size: 1.1rem;
    }
  }

  @media screen and (max-width: 768px) {
    & h4 {
      font-size: 2.5rem;
    }

    & p {
      font-size: 1rem;
    }
  }
`
